import { isMobile } from '~/src/helpers/mobile';
import { getIsActiveByTerms, getIsLocationByTerms } from '~/src/store/actions/plank';

export const checkMobilePlank = (isAuth: boolean): boolean => {
    const { search, pathname } = window.location;
    const isActiveByTerms = getIsActiveByTerms({ search, pathname  });
    const isLocationByTerm = getIsLocationByTerms(pathname);
    return !!isMobile() && (window.innerWidth < 861) && isActiveByTerms && (isAuth || isLocationByTerm);
};
